import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { getFullUrl } from '../../../shared/utils/url';
import { environment } from 'src/environments/environment';
import { MessageResponse } from "../models/message.model";

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  constructor(
    private http: HttpClient,
  ) {
  }

  getMessages(pageNum: number, pageSize: number, keywords: string): Observable<MessageResponse> {
    const fullUrl = getFullUrl(
      environment.guiBackendRootEndpoint,
      'messages',
    );
    return this.http.get<MessageResponse>(fullUrl, {
      params: {
        pageNum: pageNum,
        pageSize: pageSize,
        keyword: keywords
      }
    })
  }
}
